import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import PrivateLayout from './PrivateLayout';
import { Header } from '../components/common';
import { useAuth } from '../contexts/AuthContext';
import { routes } from '../lib/routes';
import { LogOut, ArrowLeft } from 'iconoir-react';

interface OnboardingLayoutProps {
  children?: React.ReactNode;
}

const OnboardingLayout = ({ children }: OnboardingLayoutProps) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // BUG-005 FIX: Allow users to exit onboarding
  const handleExit = () => {
    if (user?.onboarding_status === 'completed') {
      // User already completed - go to dashboard
      navigate(routes.home);
    } else {
      // User hasn't completed - offer logout
      logout();
    }
  };

  return (
    <PrivateLayout>
      <div className='bg-light'>
        <Header className='w-full' menuOpen={false} setMenuOpen={() => {}} />
        <div className='relative pt-22'>
          {/* BUG-005 FIX: Exit button for users who feel stuck */}
          <div className='fixed top-24 left-4 z-50'>
            <button
              onClick={handleExit}
              className='flex items-center gap-2 px-3 py-2 text-sm text-body-500 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors'
              title={user?.onboarding_status === 'completed' ? 'Back to Dashboard' : 'Exit & Logout'}
            >
              {user?.onboarding_status === 'completed' ? (
                <>
                  <ArrowLeft className='w-4 h-4' />
                  Dashboard
                </>
              ) : (
                <>
                  <LogOut className='w-4 h-4' />
                  Exit
                </>
              )}
            </button>
          </div>
          {children || <Outlet />}
        </div>
      </div>
    </PrivateLayout>
  );
};

export default OnboardingLayout;
